import { useQuery, useMutation, useQueryClient } from "react-query";
import { getCriticalStock, saveCriticalStock } from "@/api/Products/CriticalStock/critical-stock-query";

const key = "critical-stock";

export function useCriticalStock(product_code, option) {
	return useQuery([key, product_code], () => getCriticalStock({ product_code: product_code }), {
		enabled: product_code !== "" && product_code !== undefined && product_code !== "undefined" && option === "stock_critico",
	});
}

export function useCriticalStockSave(params) {
	const queryClient = useQueryClient();

	return useMutation(saveCriticalStock, {
		onSuccess: (_response) => {
			queryClient.invalidateQueries([key, params]);
		},
	});
}
